import { Component, Input } from '@angular/core';
var HeadingComponent = /** @class */ (function () {
    function HeadingComponent() {
        /**
         * The level of the headline
         * Note:
         * In SiteCore, the level is defined as a string and is also rendered as a string.
         * Therefore both (number & string) must be valid.
         */
        this.level = '1';
        this.levelNumeric = 1;
    }
    /**
     * Implementation of Angular's OnInit lifecyvle hook
     */
    HeadingComponent.prototype.ngOnInit = function () {
        this.validateInputs();
    };
    HeadingComponent.prototype.getClass = function () {
        return ('a-heading ' + (this.modifier ? 'a-heading--' + this.modifier : '') + ' ' + (this.class ? this.class : ''));
    };
    /**
     * Validate the input binding properties.
     */
    HeadingComponent.prototype.validateInputs = function () {
        // check heading level: only values between 1 and 6 are allowed.
        var minLevel = 1;
        var maxLevel = 6;
        // try conversion of string to number
        // this.level = +this.level;
        var numericLevel = parseFloat(this.level);
        this.levelNumeric = numericLevel;
        // validate level
        if (isNaN(numericLevel) || (numericLevel < minLevel || numericLevel > maxLevel)) {
            console.log("HeadingComponent - Validation Failure: for level (min: " + minLevel + ", max: " + maxLevel + ", level: " + this.level + "): Fallback to <h1>");
            numericLevel = 1;
        }
        // validate text
        if (!this.text) {
            console.log("HeadingComponent - Validation Warning: for text (text: " + this.text + "): No text for <h" + this.level + "> - <h" + this.level + "> is empty");
            // setting the level to 0 will prevent the rendering of the heading in the DOM (only level 1-6 are rendered)
            numericLevel = 0;
        }
        this.level = numericLevel.toString();
    };
    HeadingComponent.decorators = [
        { type: Component, args: [{
                    selector: 'cov-heading',
                    template: "<h1 *ngIf=\"levelNumeric === 1\"\r\n\t[ngClass]=\"getClass()\"\r\n\t[attr.data-t-decorator]=\"decorator\"\r\n\t[innerHTML]=\"text\"></h1>\r\n<h2 *ngIf=\"levelNumeric === 2\"\r\n\t[ngClass]=\"getClass()\"\r\n\t[attr.data-t-decorator]=\"decorator\"\r\n\t[innerHTML]=\"text\"></h2>\r\n<h3 *ngIf=\"levelNumeric === 3\"\r\n\t[ngClass]=\"getClass()\"\r\n\t[attr.data-t-decorator]=\"decorator\"\r\n\t[innerHTML]=\"text\"></h3>\r\n<h4 *ngIf=\"levelNumeric === 4\"\r\n\t[ngClass]=\"getClass()\"\r\n\t[attr.data-t-decorator]=\"decorator\"\r\n\t[innerHTML]=\"text\"></h4>\r\n<h5 *ngIf=\"levelNumeric === 5\"\r\n\t[ngClass]=\"getClass()\"\r\n\t[attr.data-t-decorator]=\"decorator\"\r\n\t[innerHTML]=\"text\"></h5>\r\n<h6 *ngIf=\"levelNumeric === 6\"\r\n\t[ngClass]=\"getClass()\"\r\n\t[attr.data-t-decorator]=\"decorator\"\r\n\t[innerHTML]=\"text\"></h6>\r\n"
                }] }
    ];
    /** @nocollapse */
    HeadingComponent.ctorParameters = function () { return []; };
    HeadingComponent.propDecorators = {
        modifier: [{ type: Input }],
        decorator: [{ type: Input }],
        level: [{ type: Input }],
        text: [{ type: Input }],
        class: [{ type: Input }]
    };
    return HeadingComponent;
}());
export { HeadingComponent };
//# sourceMappingURL=heading.component.js.map